import { useState } from "react";
import { cx } from "../presentation.tsx";
import { initials, tintFor } from "./PhotoTile.tsx";

export type AvatarRing = "brand" | "success" | "info" | "warning" | "accent" | "neutral";

export interface AvatarProps {
  name: string;
  /** Photo URL; initials on a tint when absent or when it fails to load. */
  src?: string;
  /** Children are circles, adults rounded squares (as on PhotoTile). */
  kind?: "adult" | "child";
  /** 32, 44, 64 or 88 px. */
  size?: "sm" | "md" | "lg" | "xl";
  /** A status ring around the avatar (it repeats a status the text already states). */
  ring?: AvatarRing;
  className?: string;
}

/** A photo or initials avatar for rows and headers. Decorative: the name is always next to it. */
export function Avatar({ name, src, kind = "child", size = "md", ring, className }: AvatarProps) {
  const [failed, setFailed] = useState(false);
  const photo = src && !failed;
  return (
    <span
      aria-hidden="true"
      className={cx("pmu-avatar", `pmu-avatar--${kind}`, `pmu-avatar--${size}`, ring && `pmu-avatar--ring pmu-avatar--ring-${ring}`, !photo && `pmu-tint-${tintFor(name)}`, className)}
    >
      {photo ? <img src={src} alt="" draggable={false} onError={() => setFailed(true)} /> : initials(name)}
    </span>
  );
}
